export default __webpack_public_path__ + "static/media/arrow_next.c38102a5.svg";